<template>
  <div class="">
    {{ hourModeDateFormat(day.start) }}
    <br>
    <reservation-day-price :day="day" />
  </div>
</template>


<script>
import {dateConverter, formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import ReservationDayPrice from "../ReservationDayPrice.vue";

export default {
  name: "ReservationDayMode",
  components: {ReservationDayPrice},
  props: {
    day: {}
  },
  methods: {
    formatNumber,
    dateConverter,
    hourModeDateFormat(date) {
      return dateConverter(date, '/', true).split(' ')[1].split(':').slice(0, 2).join(':')
    }
  }
}
</script>

<style scoped>

</style>